export default [
  {
    path: '/metaplanet_board',
    name: 'BoardView',
    component: () =>
      import(
        /* webpackChunkName: "metaplanet" */ '@/views/Metaplanet/BoardView.vue'
      ),
    meta: { title: 'Metaplanet Board', group: 'metaplanet' },
  },
  {
    path: '/metaplanet_mintit',
    name: 'MintitView',
    component: () =>
      import(
        /* webpackChunkName: "metaplanet" */ '@/views/Metaplanet/MintitView.vue'
      ),
    meta: { title: 'Metaplanet Mintit', group: 'metaplanet' },
  },
]
